import { FormControl } from '@mui/material';
import { Fragment, useState } from 'react';
import { Controller } from 'react-hook-form';
import { DialogDataSelect } from 'v3/shared/components/DialogDataSelect';
import { SelectFormStyled } from 'v3/shared/components/DialogDataSelect/styles';
import { StyledArrowDropDownIcon } from 'v3/shared/components/Inputs/DropdownSelectFormController/styles';
import { ErrorMessage } from 'v3/shared/components/Inputs/styles/defaultStyles';
import { IData, SelectFormControllerProps } from './types';

export const SelectFormController: React.FC<SelectFormControllerProps> = ({
  formControl,
  formControlName,
  label,
  defaultValues,
  enumType = false,
  useDefaultMapping = true,
  setValue,
  onChangeSelect,
}) => {
  const [selectItem, setSelectItem] = useState<string>('');
  const [open, setOpen] = useState<boolean>(false);

  const getDefaultValues: IData[] = [
    { key: '-', value: '' },
    ...(enumType
      ? Object.keys(defaultValues).map((key: string) => ({
        key: key,
        value: defaultValues[key],
      }))
      : useDefaultMapping
        ? (defaultValues as string[]).map((value) => ({ key: value, value }))
        : (defaultValues as IData[])),
  ];

  const setSelect = (item: string) => {
    setSelectItem(item);
    setValue(formControlName, item, { shouldValidate: true });
    onChangeSelect?.(item);
  };

  const getKeyByValue = (value: string): string => {
    if (!value) return '';
    return getDefaultValues.find((item: IData) => item.value === value)?.key || '';
  };

  return (
    <Fragment>
      <DialogDataSelect setOpen={setOpen} open={open} data={getDefaultValues} setSelectItem={setSelect} title={label} />

      <Controller
        name={formControlName}
        control={formControl}
        render={({ field: { name, value }, fieldState: { error, invalid } }) => {
          return (
            <FormControl fullWidth>
              <SelectFormStyled
                inputProps={{ 'data-testid': `select-form-controller-${name}` }}
                fullWidth
                label={label}
                name={name}
                autoComplete="off"
                placeholder="Selecione"
                onClick={() => setOpen(true)}
                onKeyDown={() => setOpen(true)}
                value={useDefaultMapping ? getKeyByValue(selectItem || value) || '' : getKeyByValue(value)}
                InputProps={{
                  readOnly: true,
                  endAdornment: <StyledArrowDropDownIcon />,
                }}
              />
              <ErrorMessage>{error?.message}</ErrorMessage>
            </FormControl>
          );
        }}
      />
    </Fragment>
  );
};
